import '../../../../lib/assets/javascripts/devex/angular/filters/lists';
import '../../utilities/angular/days_ago';
import cloudinaryImage from '../cloudinary_image/cloudinary_image.component';
import './consultant_search_result.scss';
import template from './consultant_search_result.html?raw';
import angular from 'angular';

const dependencies = ['filters.lists', 'filters.daysAgo', cloudinaryImage.name];
const options = {
  templateUrl: template,
  bindings: {
    availableFrom: '<',
    primaryPhoto: '<',
    updatedAt: '<?',
    lastProfileUpdate: '<?',
    isPublic: '<',
    headlineDisplay: '<',
    fullName: '<',
    employments: '<',
    experienceDuration: '<',
    matchesInFields: '<',
    citizenships: '<',
    country: '<',
    languages: '<',
    professionalSummary: '<',
    detailsLink: '<',
    resumes: '<',
    genderPronoun: '<',
    viewCuratedCandidateLists: '<',
    manageCuratedCandidateLists: '<',
    curatedCandidateLists: '<',
    handleSelectCuratedCandidateList: '<',
  },
  controllerAs: 'vm',
  controller: function () {
    var that = this;

    that.isMobile = window.innerWidth < 500;
    that.publishedCuratedCandidateLists = [];
    that.draftCuratedCandidateLists = [];

    that.CVHighlighted = (matchesInFields) => {
      if (matchesInFields) return matchesInFields.includes('cv');
    };

    /**
     * Returns `true` if the value of the `available_form` isn't `null` and if the date
     * is lower than the current date, otherwise returns `false`
     *
     * @returns {boolean} - `true` if the consultant is available, otherwise `false`
     */
    that.isAvailable = () => {
      if (!that.availableFrom) return false;
      return new Date(that.availableFrom).getTime() < Date.now();
    };

    /**
     * Sets the published curated candidate lists the consultant belongs to.
     *
     * @returns {void}
     */
    that.getPublishedCuratedCandidateLists = () => {
      that.publishedCuratedCandidateLists = that.curatedCandidateLists.filter(
        (list) => list.workflow_state === 'published'
      );
    };

    /**
     * Sets the draft curated candidate lists the consultant belongs to.
     *
     * @returns {void}
     */
    that.getDraftCuratedCandidateLists = () => {
      if (!that.manageCuratedCandidateLists) return;

      that.draftCuratedCandidateLists = that.curatedCandidateLists.filter(
        (list) => list.workflow_state === 'draft'
      );
    };

    that.$onInit = function () {
      if (that.curatedCandidateLists) {
        that.getPublishedCuratedCandidateLists();
        that.getDraftCuratedCandidateLists();
      }
    };
  },
};

angular
  .module('components.consultantSearchResult', dependencies)
  .run(['$templateCache', function ($templateCache) {
    $templateCache.put(template, template);
  }])
  .component('consultantSearchResult', options);
